
/* eslint-disable react/no-danger */

import React from 'react'
import PropTypes from 'prop-types'

const SvgIcon = ({ svg, className }) => (
  <span
    className={className}
    dangerouslySetInnerHTML={{ __html: svg }}
    style={{ display: 'inline-flex' }}
  />
)

SvgIcon.propTypes = {
  svg: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default SvgIcon
